import Vue from 'vue'
import VueRouter from 'vue-router'

////Dashboard main
import dashboard from '../components/dashboard/dashBoardmain'

///configure
import confiGure from '../components/dashboard/confiGu.vue'

import agentDetail from "../components/dashboard/agentDetail.vue";

import signin from "../components/clientAuth/SignIn.vue";
import agentForm from "../components/dashboard/agentForm.vue";
import aggreeMent from "../components/dashboard/aggreeMent.vue";
import listAllAgent from "../components/dashboard/listAllAgent.vue";
import viewAgent from "../components/dashboard/viewAgent.vue";
import dashboardIn from "../components/dashboard/dashboardIn.vue"
import agentInfo from "../components/dashboard/agentData.vue"

Vue.use(VueRouter)


// import axios from 'axios'
// import VueCookies from 'vue-cookies'



const routes = [
  
{
  path: '/dashpanel',
  name: 'dashboard',
  component: dashboard,

        children:[
          {
            path: '/dashboard',
            name: 'dashboardIn',
            component: dashboardIn,
            meta: {
              checkurl:true
            },
          },
          {
            path: '/agent-details/:agent',
            name: 'agentDetails',
            component: agentInfo,
          },
          {
            path: '/configure',
            name: 'configure',
            component: confiGure,
            meta: {
              checkurl:true
            },
          },
          {
            path: '/agentDetails/:id',
            name: 'agentDetails',
            component: agentDetail,
            meta: {
              checkurl:true
            },
          },
          {
            path: '/createAgent',
            name: 'agentForm',
            component: agentForm
          },
          {
            path: '/aggreeMent',
            name: 'aggreeMent',
            component: aggreeMent
          },
          {
            path: '/listAllAgent',
            name: 'listAllAgent',
            component: listAllAgent
          },
          {
            path: '/viewAgent',
            name: 'viewAgent',
            component: viewAgent
          },
          
        ]
      },
      {
        path: '/',
        name: 'signin',
        component: signin,
        meta: {
          checkurl:true
        },
      },


]

const router = new VueRouter({
  routes
})

export default router
